// extracted by mini-css-extract-plugin
module.exports = {"image":"disrupter-tiles_image__8bc_t","image-wrapper":"disrupter-tiles_image-wrapper__7MwPy"};